<template>
  <div class="work-page">
    <div class="title">个人信息</div>
    <van-form @submit="onSubmit">

      <van-field
          label="姓名"
          v-model="username"
          name="username"
          placeholder="请填写"
          :class="{'field-focus': focuseModel === 'f1'}"
          @focus="filedFocus('f1')"
          @blur="filedFocus('')"
          :rules="[{ required: true, message: '' }]"
      />

      <van-field
          label="性别"
          clickable
          readonly
          name="sexPicker"
          :value="sex.name"
          placeholder="请选择"
          @click="showPicker = true"
          :class="{'field-focus': focuseModel === 'f2'}"
          @focus="filedFocus('f2')"
          @blur="filedFocus('')"
          right-icon="arrow"
          :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model="showPicker" round :close-on-popstate="true" position="bottom">
        <van-picker
            title="性别"
            show-toolbar
            :columns="sexList"
            value-key="name"
            @confirm="onConfirmSex"
            @cancel="showPicker = false"
        />
      </van-popup>

      <van-field
          label="电话号码"
          v-model="mobile"
          name="mobile"
          type="tel"
          :class="{'field-focus': focuseModel === 'f3'}"
          @focus="filedFocus('f3')"
          @blur="filedFocus('')"
          placeholder="请填写"
          :rules="[{ required: true, message: '' },
              { validator:validatorPhone, message: '' }
          ]"
      />

      <van-field
          label="电子邮件"
          v-model="email"
          name="email"
          placeholder="电子邮件"
          :class="{'field-focus': focuseModel === 'f4'}"
          @focus="filedFocus('f4')"
          @blur="filedFocus('')"
          :rules="[{ required: true, message: '' },
             { validator:validatorEmail, message: '' }
          ]"
      />
      <van-field
          label="参加工作年月"
          clickable
          readonly
          name="datetime"
          :value="startwork_date|formatshortDate"
          placeholder="请选择"
          :class="{'field-focus': focuseModel === 'f5'}"
          @focus="filedFocus('f5')"
          @blur="filedFocus('')"
          @click="showDatePicker = true"
          right-icon="arrow"
      />
      <van-popup v-model="showDatePicker" round :close-on-popstate="true" position="bottom">
        <van-datetime-picker
            title="选择年月"
            type="year-month"
            v-model="datetime"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="onConfirmDate"
            :formatter="formatter"
            @cancel="showDatePicker = false"
        />
      </van-popup>
      <div class="submit-content">
        <van-button class="submit-btn" block :class="{'disabled':!isAvailable}"  type="info" native-type="submit" ><span>保存</span></van-button>
      </div>
    </van-form>


  </div>
</template>

<script>
import {mapState} from "vuex";
import cookies from "@/libs/util.cookies";
import {Toast} from "vant";
import { isEmail, isPhone }  from '@/libs/validate'
import dayjs from "dayjs";
import util from "../../../libs/util";
export default {
  name: 'ResumeWork',
  data() {
    return {
      user_id: cookies.get('uid') || '',
      username: '',
      startwork_date:'',
      datetime: new Date(),
      sex:'',
      email:'',
      focuseModel:'',
      minDate: new Date(1990, 0, 1),
      maxDate: new Date(new Date().getFullYear() + 10, 11, 31),
      sexList: [
        {
          value:0,
          name:'男',
        },
        {
          value:1,
          name:'女',
        },
        {
          value:2,
          name:'其他'
        }],
      mobile:'',
      showPicker:false,
      showDatePicker:false,
    }
  },
  computed: {
    ...mapState('dic', ['educationTypeList']),
    isAvailable (){
      return this.username&&this.sex&&this.email&&this.mobile
    }
  },
  created() {
    const shareParam = {
      title: "卫宁健康期待您的加入",
      desc: "正在热招",
      link: process.env.VUE_APP_BASEURL +'#/',
      imgUrl: process.env.VUE_APP_SHARE_IMG_URL
    }
    util.initWXSdk(shareParam)
  },
  mounted() {
    if(this.$route.params.info){
      const info = JSON.parse(this.$route.params.info)
      this.username = info.name
      this.startwork_date = info.startwork_date
      this.mobile = info.mobile
      this.email = info.email
      this.sex = this.sexList.filter(item=>{
        return item.value == info.sex
      })[0]
    }
  },
  methods: {
    filedFocus(value){
      this.focuseModel = value
    },
    validatorPhone(val){
      return isPhone(val)
    },
    validatorEmail(val){
      return isEmail(val)
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    onSubmit(){
      const param = {
        email:this.email,
        name:this.username,
        sex:this.sex.value,
        mobile:this.mobile,
        user_id: this.user_id
      }
      if(this.startwork_date){
        param.startwork_date = dayjs(this.startwork_date).format('YYYY-MM-DD')
      }
      this.$api.RESUME_SAVE(param).then(()=>{
        Toast( '信息更新成功')
        this.$router.go(-1)
      })
    },
    onConfirmDate(date) {
      this.startwork_date = date
      this.showDatePicker = false;
    },
    onConfirmSex(sex) {
      this.sex = sex;
      this.showPicker = false;
    },
  },
}
</script>

<style scoped>
.title{
  font-size: 24px;
  font-weight: bold;
  color: #333333;
}
.work-page{
  text-align:left;
  padding-bottom:65px;
}
.work-page .title{
  padding:10px 20px;
  margin:10px 0 0 0;
}

.submit-content{
  position:fixed;
  bottom:20px;
  left:20px;
  right: 20px;

}

.submit-btn{
  flex:1;
  height:44px;
  background: linear-gradient(90deg, #3871FF 0%, #2E5DD2 100%);
  border-radius: 22px;
  font-size:16px;
  font-weight: bold;
  color:#fff;
}

.submit-btn.disabled span{
  opacity:0.5;
}

.submit-btn-cancel span{
  display:block;
  text-align: center;
  line-height:44px;
}
::v-deep .submit-btn.van-button--disabled{
  opacity:1;
}

::v-deep .submit-btn.van-button--disabled span{
  opacity:0.5;
}

::v-deep .van-cell{
  display:block;
  line-height:28px;
  padding:13px 20px;
  font-size:16px;
  color:#333;
  border-color:#F1F4F6;
}

/* ::v-deep .van-field__error-message{
  display:none;
} */

::v-deep .van-cell__title{
  font-size:12px;
  color:#999;
  padding-bottom:5px;
}

.field-focus::after{
  border-color:#3163E0;
  transform: scaleY(1);
}

::v-deep .field-arrow .van-cell__value{
  position: relative;
  padding-right:20px;
}

::v-deep .field-arrow .van-cell__value::after{
  display:block;
  content:'';
  width:19px;
  height:16px;
  background:url(../../../assets/images/mine/icon-arrow.png);
  background-size:19px 16px;
  position: absolute;
  right:0;
  top:0;
  margin:8px 0;
}

::v-deep .van-picker__confirm{
  color:#3871FF;
}
</style>
